/**
 * inputPasswordConfirmationDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

inputPasswordConfirmationDirective.$inject = [];

export function inputPasswordConfirmationDirective() {
    return {
        // language=HTML
        template: `
            <div class="form-row app-input-password-confirmation-container">
                <md-input-container flex="50">
                    <label>Password</label>

                    <input type="password"
                           name="{{ name || '' }}"
                           ng-model="_value.password"
                           ng-model-options="{ debounce: { 'default': 300, 'blur': 0 } }"
                           ng-required="required"
                           data-testid="input:password"
                           ng-minlength="minLength">

                    <div ng-if="form && name" ng-messages="form[name].$error">
                        <div ng-message="required">Required</div>
                        <div ng-message="custom">{{ form[name].customError }}</div>
                        <div ng-message="minlength">Password is too short</div>
                    </div>

                </md-input-container>

                <md-input-container flex="50">
                    <label>
                        Confirm password
                    </label>

                    <input type="password"
                           name="{{ name + '_confirmation' }}"
                           ng-model="_value.confirmation"
                           ng-model-options="{debounce: { 'default': 300, 'blur': 0}}"
                           compare-to="_value.password"
                           ng-required="required"
                           data-testid="input:confirm-password"
                           ng-minlength="{{ minLength }}">

                    <div ng-if="form && name" ng-messages="form[name + '_confirmation'].$error">
                        <div ng-message="required">Required</div>
                        <div ng-message="custom">{{ form[name + '_confirmation'].customError }}</div>
                        <div ng-message="minlength">Password is too short</div>
                        <div ng-message="compareTo">Passwords don't match</div>
                        <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                    </div>
                </md-input-container>
            </div>
        `,
        scope: {
            form: '=form',
            minLength: '=?minLength',
            name: '@name',
            value: '=value',
            valueConfirmation: '=?valueConfirmation',
            required: '=?required',
        },
        link: function(scope, element, attrs) {
            element.addClass('app-form-field');

            scope._value = {
                password: null,
                confirmation: null,
            };

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }

            scope.$watch('_value.password', _checkForValidPassword, true);
            scope.$watch('_value.confirmation', _checkForValidPassword, true);

            function _checkForValidPassword() {
                console.log('_checkForValidPassword');

                if (scope.form && scope.name) {
                    scope.form[scope.name].$setValidity('custom', true);
                    scope.form[scope.name].customError = null;
                    scope.form[`${scope.name}_confirmation`].$setValidity('custom', true);
                    scope.form[`${scope.name}_confirmation`].customError = null;
                }

                if (
                    scope._value.password &&
                    scope._value.confirmation &&
                    scope._value.password === scope._value.confirmation &&
                    scope.form[scope.name].$valid &&
                    scope.form[`${scope.name}_confirmation`].$valid
                ) {
                    scope.value = scope._value.password;
                    scope.valueConfirmation = scope._value.password;
                } else {
                    console.log('not valid');

                    scope.value = scope.value === undefined ? undefined : null;
                }
            }
        },
    };
}
